/**
 * Password Strength Indicator Component
 * Shows visual feedback for password strength
 */
import React from 'react';
import { checkPasswordStrength } from '../../utils/validation';

const PasswordStrengthIndicator = ({ password }) => {
  if (!password) return null;

  const { strength, score, feedback } = checkPasswordStrength(password);

  const strengthColors = {
    weak: 'bg-red-500',
    medium: 'bg-yellow-500',
    strong: 'bg-green-500',
  };

  const strengthLabels = {
    weak: 'Lemah',
    medium: 'Sedang',
    strong: 'Kuat',
  };

  const strengthTextColors = {
    weak: 'text-red-600',
    medium: 'text-yellow-600',
    strong: 'text-green-600',
  };

  return (
    <div className="mt-2">
      {/* Strength Bar */}
      <div className="flex items-center gap-2 mb-2">
        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-300 ${strengthColors[strength]}`}
            style={{ width: `${(score / 5) * 100}%` }}
          />
        </div>
        <span className={`text-xs font-medium ${strengthTextColors[strength]}`}>
          {strengthLabels[strength]}
        </span>
      </div>

      {/* Feedback Messages */}
      {feedback.length > 0 && (
        <div className="text-xs text-gray-600 space-y-1">
          {feedback.map((msg, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="text-red-500">•</span>
              <span>{msg}</span>
            </div>
          ))}
        </div>
      )}

      {/* Password Requirements (shown when password is empty or weak) */}
      {password.length > 0 && strength === 'weak' && (
        <div className="mt-2 text-xs text-gray-500">
          <p className="font-medium mb-1">Password harus memenuhi:</p>
          <ul className="list-disc list-inside space-y-0.5">
            <li>Minimal 8 karakter</li>
            <li>Huruf kecil dan besar</li>
            <li>Angka</li>
            <li>Karakter khusus</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default PasswordStrengthIndicator;
